"use client";
import React, { useRef, useState, useEffect } from "react";
import { z } from "zod";
import {
  RealtimeAgent,
  RealtimeSession,
  tool,
  OpenAIRealtimeWebRTC,
} from "@openai/agents-realtime";
import axios from "axios";
import {
  BsMicFill,
  BsMicMuteFill,
  BsFillPlayCircleFill,
  BsFillPauseCircleFill,
} from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../context";
import { apiUrl } from "../../../utils/config";

export default function Live({ onStop = () => {} }) {
  const hasRun = useRef(false);
  const [session, setSession] = useState(null);
  const [state, setState] = useState("idle");
  const [muted, setMuted] = useState(false);
  const navigate = useNavigate()
  const [showCart, setShowCart] = useState(false);
  const [payment, setPayment] = useState(false);
  const [voiceState,setVoiceState] = useState("stopped")
  const {cart, addOrder, cartTotal, clearCart,isCartOpen, setIsCartOpen, addToCart,updateQty,removeFromCart} = useAppContext();
  const cartRef = useRef(cart);
  
  const fetchProducts = async () => {
  const { data } = await axios.get(apiUrl+"/menuItem");
  return data.list;
};

  const [data, setData] = useState([]);

  /* ---------------- TOOLS ---------------- */

  const getProductInfo = tool({
    name: "getProductInfo",
    description: "Get details of product",
    parameters: z.object({}),
    execute: async ({ item }) => {
      const res = await axios.get(`${apiUrl}/menuItem`, {
        headers: {
          "auth-token": "1214",
          "Content-Type": "application/json",
        },
      });
      //let products = res.data ;
       let products = []
      if(res.data && res.data.status && res.data.list && res.data.list.length > 0){
       products =  res.data.list.map((i)=>{
              return {
                id: i.id,
                name: i.name,
                price:i.price,
                category:i?.category?.name,
                images:i.images
              }
            })
      }

      setIsCartOpen(true);
      
      return {
        status :true,
        products:products
      }
    },
  });


  useEffect(() => {
    cartRef.current = cart;
  }, [cart]);

  const addItemToCart = tool({
    name: "addItemToCart",
    description: "Add or remove items  from cart",
    parameters: z.object({
      id: z.number(),
      name: z.string(),
      price: z.number(),
      images:z.any(),
      type:z.boolean()
    }),
    execute: async (input) => {
      console.log(cartRef.current)

      let itemExists = cartRef.current.find(i => i.id == input.id);

      let prevQty = cartRef.current.find(i => i.id == input.id)?.quantity || 0;
      let product = {
        id: input.id,
        price:input.price,
        quantity: 1 ,
        name: input?.name,
        images:input?.images
       }

       if(itemExists && itemExists.id > 1){
          if(input.type){
          
        updateQty(input.id , +1)
           
       }else{
        
         removeFromCart(input.id )
       }
       }else{
          addToCart(product)
       }

     
    
      return { success: true };
    },
  });

  const getCartInfo = tool({
    name: "getCartInfo",
    description: "Get  cart information",
    parameters: z.object({}),
    execute: async (input) => {
      setIsCartOpen(true);
      
      return cartRef.current;
    },
  });

  const clearTheCart = tool({
    name: "clearTheCart",
    description: "clear the cart",
    parameters: z.object({}),
    execute: async (input) => {
      setIsCartOpen(true);
      clearCart()
      return cartRef.current;
    },
  });

const gotoPage = tool({
  name: "gotoPage",
  description: "based on page requested go to that page",
  parameters: z.object({
    name: z.string(),
  }),
  execute: async (input) => {
    setIsCartOpen(false);

    console.log(input);

    switch (input.name) {
      case "home":
        navigate("/");
        break;

      case "checkout":
        navigate("/checkout");
        break;

      case "contact":
        navigate("/contact");
        break;

      case "menu":
        navigate("/menu");
        break;

      case "blog":
        navigate("/blog");
        break;

      case "about":
        navigate("/about");
        break;

      case "profile":
        navigate("/profile");
        break;

      default:
        navigate("/");
        break;
    }

    return true;
  },
});

 

  /* ---------------- TRANSPORT ---------------- */

  const initTransport = async () => {
    const mediaStream = await navigator.mediaDevices.getUserMedia({
      audio: true,
    });

    return new OpenAIRealtimeWebRTC({
      mediaStream,
      audioElement: document.createElement("audio"),
    });
  };

  /* ---------------- INIT ---------------- */

  const init = async () => {
    if (hasRun.current) return;
    hasRun.current = true;

    const agent = new RealtimeAgent({
      name: "Data Agent",
      response_mode: "tool", // 🔒 FORCE TOOLS
      instructions: `
You are a data agent.

Rules (STRICT):
- Always respond in English.
- you never answer question other these mentioned things here
- this store works from 9 am to 1 pm and 1pm to 2pm lunch time and 2pm to 6pm working timings, store offer various indian
foods to serve its customers 
- For prices, products, or cart actions you MUST call a tool.
- Never answer from memory.
- If a tool applies, you are NOT allowed to speak.
- you just always call tools only 
- If no tool exists, say: "Required tool not available."
`,
      tools: [
        getProductInfo,
        getCartInfo,
        gotoPage,
        addItemToCart,
        clearTheCart
      ],
    });

    try {
       setVoiceState("loading")
        const res = await axios.post(apiUrl+"/ai/voice/session", {
      message: "",
    });
    
   if (!res.data?.value) return;

 
    const transport = await initTransport();
    const newSession = new RealtimeSession(agent, { transport });

    await newSession.connect({ apiKey: res.data.value });

    /* -------- TOOL LOGGING -------- */

    newSession.on("transport_event", (event) => {

      //console.log(event.type);

      if (event.type === "tool.call") {
        console.log("Tool Call:", event.tool.name, event.tool.arguments);
      }

      if (event.type === "tool.result") {
        console.log(" Tool Result:", event.tool.name, event.result);
      }

      if(event.type === "input_audio_buffer.speech_stopped"){
        setVoiceState("processing")
      }

      if(event.type === "output_audio_buffer.started"){
        setVoiceState("speaking")
      }

      if(event.type === "output_audio_buffer.stopped"){
        setVoiceState("listening")
      }


      if (event.type === "session.created") {
        setVoiceState("listening");
      }
    });

    setSession(newSession);
     setVoiceState("listening")
    } catch (error) {
        console.log(error)
        setVoiceState("listening")
    }

  
  };

  /* ---------------- CONTROLS ---------------- */
  const stop = () => {
    session?.close();
    setSession(null);
    setState("idle");
    setVoiceState("stopped")
    hasRun.current = false;
    onStop();
  };
  const handleMuteToggle = () => {
    if (!session) return;
    session.mute(!muted);
    setMuted(!muted);
  };

  const startVoice = ()=> {
    init()
  }


  /* ---------------- UI ---------------- */

  return (
   <>
     <div className="flex-1 flex flex-col items-center justify-center p-5 text-center">
              {voiceState === "stopped" && (
                <>
                  <div className="w-24 h-24 bg-gradient-to-br from-orange-100 to-red-100 rounded-full flex items-center justify-center mb-5 text-4xl aflt">🎤</div>
                  <h3 className="font-bold text-gray-900 mb-1 text-sm">Voice Assistant</h3>
                  <p className="text-xs text-gray-400 mb-6 leading-relaxed">Tap the button and speak your question. Gampa will respond instantly.</p>
                  <button onClick={()=>{
                    startVoice()
                  }} className="bg-gradient-to-r from-[#f97316] to-red-500 text-white font-black px-8 py-3 rounded-2xl hover:scale-105 transition-transform btn-press shadow-lg shadow-orange-200 text-sm">
                    🎤 Tap to Speak
                  </button>
                </>
              )}
                {voiceState === "loading" && (
                <>
                  <p className="font-bold text-gray-900 mb-1 text-sm">Loading...</p>
                </>
              )}
              {voiceState === "listening" && (
                <>
                  <div className="relative mb-5">
                    <div className="w-24 h-24 bg-gradient-to-br from-[#f97316] to-red-500 rounded-full flex items-center justify-center text-4xl shadow-xl shadow-orange-300/50">🎤</div>
                    {[1, 2].map(r => <div key={r} className="absolute inset-0 rounded-full border-2 border-orange-400 opacity-60" style={{ animation: `ripple 1.5s ${r * 0.4}s ease-out infinite` }} />)}
                  </div>
                  <p className="font-bold text-gray-900 mb-1 text-sm">Listening...</p>
                  <p className="text-xs text-gray-400 mb-4">Speak your question now</p>
                  <div className="flex items-end gap-1 h-8">
                    {[...Array(14)].map((_, i) => <div key={i} className="w-1.5 bg-gradient-to-t from-[#f97316] to-red-400 rounded-full" style={{ height: `${12 + Math.sin(i * 0.6) * 10}px`, animation: `wave 1s ${i * 0.08}s ease-in-out infinite` }} />)}
                  </div>
                </>
              )}
              {voiceState === "processing" && (
                <>
                  <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-5">
                    <div className="w-8 h-8 border-3 border-[#f97316] border-t-transparent rounded-full spn border-[3px]" />
                  </div>
                  <p className="font-bold text-gray-900 mb-1 text-sm">Processing...</p>
                </>
              )}
              {voiceState === "speaking" && (
                <>
                  <div className="w-24 h-24 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center text-4xl mb-5 shadow-xl shadow-green-200">🔊</div>
                  <p className="font-bold text-gray-900 mb-3 text-sm">Gampa is responding...</p>
                  <div className="flex items-end gap-1 h-6">
                    {[...Array(10)].map((_, i) => <div key={i} className="w-1.5 bg-gradient-to-t from-green-500 to-emerald-400 rounded-full" style={{ height: `${8 + Math.sin(i * 0.7) * 6}px`, animation: `wave 1s ${i * 0.1}s ease-in-out infinite` }} />)}
                  </div>
                  <button onClick={() => setVoiceState("idle")} className="mt-5 text-xs font-bold text-gray-400 hover:text-gray-600">Ask another question →</button>
                </>
              )}

              { voiceState != "stopped" && voiceState != "loading" &&  <button onClick={()=>{
                    stop()
                  }} className="bg-gradient-to-r my-2 from-red-500 to-black text-white font-black px-8 py-3 rounded-2xl hover:scale-105 transition-transform btn-press shadow-lg shadow-orange-200 text-sm">
                  STOP
                  </button> }
            </div>
   </>
  );
}
